import { BlockStack, InlineStack, SkeletonBodyText, SkeletonDisplayText, SkeletonThumbnail, Text } from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const CloseMatchSkeleton = () => {
    const { t } = useTranslation();
    const columns: any = [
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Amazon")}</Text>,
            dataIndex: "amazon",
            key: "amazon",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Shopify")}</Text>,
            dataIndex: "shopify",
            key: "shopify",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Action")}</Text>,
            key: "action",
            width: 100,
            align: "center",
            dataIndex: "action",
        }
    ];
    const rows: any = [
        {
            key: '1',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '2',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '3',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '4',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '5',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '6',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '7',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
        {
            key: '8',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className='skeleton-action'>
                <SkeletonDisplayText size="small" />
            </div>,
        },
    ];
    return <Table sticky columns={columns} dataSource={rows} scroll={{ x: 700 }} pagination={false} size='middle' />;
};

export const UnlinkingSkeleton = () => {
    const { t } = useTranslation();
    const columns: any = [
        {
            title: "",
            dataIndex: "image",
            key: "image",
            width: 70,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                {t("Product")}
            </Text>,
            dataIndex: "product",
            key: "product",
            width: 400,
        },
        {
            title: "",
            dataIndex: "status",
            key: "status",
            width: 100,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                Amazon SKU and Barcode
            </Text>,
            dataIndex: "sku",
            key: "sku",
            width: 250,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                Action
            </Text>,
            dataIndex: "action",
            key: "action",
            width: 150,
            align: 'center',
        },
    ];
    const rows: any = [
        {
            key: '1',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '2',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '3',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '4',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '5',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '6',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
        {
            key: '7',
            image: <SkeletonThumbnail size="medium" />,
            product: <BlockStack gap="300" inlineAlign='start'>
                <SkeletonBodyText lines={2} />
                <div className='Custom__Unlinked--Action'>
                    <SkeletonDisplayText size="small" />
                </div>
            </BlockStack>,
            status: <div className='Custom__Unliked--Badge'>
                <SkeletonBodyText lines={1} />
            </div>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <InlineStack gap="200" align='center'>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonThumbnail size="extraSmall" />
                </InlineStack>
            </div>,
        },
    ];
    return <Table sticky columns={columns} dataSource={rows} scroll={{ x: 800 }} pagination={false} size='middle' />;
};

export const DeletingSkeleton = () => {
    const { t } = useTranslation();
    const columns: any = [
        {
            title: '',
            dataIndex: 'image',
            key: 'image',
            width: 50,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Product</Text>,
            dataIndex: 'product',
            key: 'product',
            width: 150,
        },
        {
            title: '',
            dataIndex: 'amazon',
            key: 'amazon',
            align: 'center',
            width: 150,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Amazon SKU and Barcode</Text>,
            dataIndex: 'sku',
            key: 'sku',
            width: 150,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Action</Text>,
            key: 'action',
            dataIndex: 'action',
            width: 100,
            align: 'center',
        },
    ];
    const rows: any = [
        {
            key: '1',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '2',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '3',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '4',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '5',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '6',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '7',
            image: <SkeletonThumbnail size="medium" />,
            product: <SkeletonBodyText lines={2} />,
            amazon: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            sku: <SkeletonBodyText lines={2} />,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
    ];
    return <Table sticky columns={columns} dataSource={rows} scroll={{ x: 800 }} pagination={false} size='middle' />;
};

export const LinkSkeleton = () => {
    const { t } = useTranslation();
    const columns: any = [
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Amazon</Text>,
            dataIndex: "amazon",
            key: "amazon",
            width: 400,
        },
        {
            title: "",
            key: "status",
            dataIndex: "status",
            width: 100,
            align: "center",
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Shopify</Text>,
            dataIndex: "shopify",
            key: "shopify",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Action</Text>,
            key: "action",
            dataIndex: "action",
            width: 200,
            align: "center",
        }
    ];
    const rows: any = [
        {
            key: '1',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '2',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '3',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '4',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '5',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '6',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '7',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
        {
            key: '8',
            amazon: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            status: <BlockStack inlineAlign='center'>
                <div className='Custom__Unliked--Badge'>
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>,
            shopify: <div className='skeleton-amazon-category'>
                <InlineStack gap="300" wrap={false}>
                    <SkeletonThumbnail size="medium" />
                    <BlockStack gap="300" inlineAlign='start'>
                        <div>
                            <SkeletonBodyText lines={3} />
                        </div>
                        <div className='skeleton-action'>
                            <SkeletonDisplayText size="small" />
                        </div>
                    </BlockStack>
                </InlineStack>
            </div>,
            action: <div className="skeleton-action-linking">
                <SkeletonDisplayText size="medium" />
            </div>,
        },
    ];
    return <Table sticky columns={columns} dataSource={rows} scroll={{ x: 700 }} pagination={false} size='middle' />;
};